<template>
  <div class="home texture-bg-css">
    <Carousels></Carousels>
    <MillenniumKiln></MillenniumKiln>
    <PanoramasNav type="page" position="home"></PanoramasNav>
    <Ceramic></Ceramic>
    <VideosBar></VideosBar>
    <Tour></Tour>
    <section class="news mx-auto relative w clearfix cursor-default">
      <div class="text-center content-title">
        <span class="inline-block line-css"></span>
        <span class="font-css"> <span>公告</span> NOTIFICATION </span>
        <span class="inline-block line-css"></span>
      </div>
      <div class="news-content">
        <div class="clearfix">
          <span class="float-left news-title">公告&emsp;NOTIFICATION</span>
          <div
            class="more more-deep float-right"
            @click="
              link({
                type: 'list',
                link: '/list',
                category: 'news'
              })
            "
          >
            更多 | MORE
          </div>
        </div>
        <ListBar name="近期公告" data="news" :pageSize="9" :type="2"></ListBar>
      </div>
    </section>
  </div>
</template>

<script>
import link from '@/core/mixins/link'
import ListBar from '@/components/home/HomeList'
import Carousels from '@/components/home/Carousels'
import MillenniumKiln from '@/components/home/MillenniumKiln'
import VideosBar from '@/components/home/Videos'
import PanoramasNav from '@/components/home/PanoramasNav'
import Ceramic from '@/components/home/Ceramic'
import Tour from '@/components/home/Tour'

export default {
  name: 'home',
  components: {
    ListBar,
    Carousels,
    MillenniumKiln,
    VideosBar,
    PanoramasNav,
    Ceramic,
    Tour
  },
  mixins: [link],
  data() {
    return {}
  },
  mounted: function() {},
  methods: {
    newPageJump(item) {
      window.open(item.link, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.home {
  padding-bottom: 80px;
  min-height: 80vh;
  .news {
    .news-title {
      color: $c-white;
      font-size: 22px;
      line-height: 38px;
      margin-bottom: 35px;
    }
    .news-content {
      padding: 30px 35px;
      background-color: $c-tour-bg-yellow;
      ::v-deep  .il-list-content li {
        line-height: 30px;
      }
    }
  }
}
</style>
